import playButton from '../assets/icons/play_button.png'
import { btnOneLight, subTitle } from '../utils/style';
import clockIcon from '../assets/icons/clock_icon.png'

function CertificationCard({ id, image, title, date, lessons, duration, completed }) {

    return(
        <div className='p-4 rounded-lg shadow-lg my-2' key={id}>
            <div className='flex w-full'>
                <div>
                    <img src={image}  height={150} width={150}/>
                </div>
                <div className='flex-1'>
                    <div className='flex gap-4 items-center py-1'>
                        <div className={subTitle}>{title}</div>
                        <div className='text-md text-gray-500'>{`(${lessons} Lessons)`}</div>
                    </div>
                    <div className='py-2 text-md text-gray-500'>{`Date: ${date}`}</div>
                    <div className='flex gap-2 items-center'>
                        <div className='flex-1'>
                            <div className={btnOneLight}>
                                <img src={clockIcon}/>
                                <div className='ml-2 text-sm font-semibold'>{duration}</div>
                            </div>
                        </div>
                        <div>
                            <img src={playButton} className='cursor-pointer' height={40} width={40} />
                        </div>
                    </div>
                </div>
            </div>
            <div className='flex gap-2 items-center py-1'>
                <div className='flex-1'>
                    <div className={`bg-customOne h-1 w-[${completed}%] rounded-lg`}></div>
                </div>
                <div className='py-2 text-md text-gray-500'>{completed}%</div>
            </div>
        </div>
    )
}

export default CertificationCard;